// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// NOTE - this is used in the Path Import CSV Results table
// as well as the Path DB Search, Project Path Summary table
// and the Path Lookup

const getSiteValues = (columnKey, rowData) => {
  // get the specified value based on the site's indexes and the column key.
  // column key will be something like, 'siteName', so site1Value would be
  // the site name of site 1.

  // if site1Value and site2Value need formatting in their rendering,
  // you can override the definition of the this.BasicSite1/this.BasicSite2 renderers

  // if we're using the Path Import CSV Result table,
  // then the prop name is segmentEndImport1 and not site1.
  const site1Value = (
    rowData.site1 !== undefined
      ? rowData.site1[columnKey]
      : rowData.segmentEndImport1[columnKey]
  )

  const site2Value = (
    rowData.site2 !== undefined
      ? rowData.site2[columnKey]
      : rowData.segmentEndImport2[columnKey]
  )

  return ({
    site1Value,
    site2Value,
  })
}

export default getSiteValues
